import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'
import { FeatureService } from './feature.service'

@Injectable({
  providedIn: 'root',
})
export class DebugGuard implements CanActivate {
  constructor(private featureService: FeatureService) {}

  public canActivate(): Observable<boolean | UrlTree> {
    return this.featureService.accessToken$.pipe(
      map((accessToken) => {
        return accessToken.activated.features.debug
      }),
      first(),
    )
  }
}
